export enum BadgeSize {
  Small = 'small',
  Medium = 'medium',
}
